import React from 'react';
import { FileDown } from 'lucide-react';

const SubscribersTab = ({ subscribers, exportCSV }) => (
  <div className="data-table">
    <div className="table-header-row">
      <h2 className="section-heading">Recent Subscribers</h2>
      <button onClick={() => exportCSV('subscribers')} className="export-btn-sm" data-testid="export-subscribers-tab"><FileDown size={16} /> CSV</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>Email</th>
          <th>Source</th>
          <th>Subscribed</th>
          <th>Email Status</th>
          <th>Digest</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        {subscribers.map((sub) => (
          <tr key={sub.id}>
            <td>{sub.email}</td>
            <td><span className="badge">{sub.source}</span></td>
            <td>{new Date(sub.subscribed_at).toLocaleDateString()}</td>
            <td>Email {sub.email_sequence_status}/4</td>
            <td>{sub.weekly_digest ? 'Ya' : 'Tidak'}</td>
            <td>{sub.is_active ? '✅' : '❌'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SubscribersTab;
